import React from 'react';
import Icon from '../../../components/AppIcon';
import CommerceMonthCalendar from './CommerceMonthCalendar';
import './ReservationClassicEmbedded.css';

/**
 * Bloc réservation intégré — thème « Classique » (carte neutre + calendrier).
 * La page dédiée (bouton) conserve l’ancien parcours plein écran dans ReservationPublicView.
 */
export default function ReservationClassicEmbedded({
  display,
  accent,
  btnBg,
  btnText,
  done,
  name,
  partySize,
  maxParty,
  setPartySize,
  selectedDate,
  setSelectedDate,
  setTimeSlot,
  setError,
  minDate,
  availabilityConfigured,
  isDayDisabled,
  timeSlot,
  availableSlots,
  email,
  setEmail,
  phone,
  setPhone,
  setName,
  note,
  setNote,
  error,
  busy,
  interactive,
  submit,
  submitLabel = 'Demander ma réservation',
}) {
  if (done) {
    return (
      <div className="jop-classic-reservation-embedded">
        <div className="jop-classic-reservation-embedded__card jop-classic-reservation-embedded__card--done">
          <div
            className="jop-classic-reservation-embedded__check"
            style={{ backgroundColor: `${accent}18`, color: accent }}
          >
            <Icon name="Check" size={22} />
          </div>
          <h3 className="jop-classic-reservation-embedded__done-title">C&apos;est noté</h3>
          <p className="jop-classic-reservation-embedded__done-text">
            Merci {name.split(' ')[0] || ''}. Nous revenons vers vous pour {partySize} convive
            {partySize > 1 ? 's' : ''}.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="jop-classic-reservation-embedded">
      <form onSubmit={submit} className="jop-classic-reservation-embedded__card">
        <h3 className="jop-classic-reservation-embedded__title">
          {display.formTitle || 'Réserver votre table'}
        </h3>
        {display.formSubtitle ? (
          <p className="jop-classic-reservation-embedded__subtitle">{display.formSubtitle}</p>
        ) : null}

        <div className="jop-classic-reservation-embedded__picker-row">
          <label className="jop-classic-reservation-embedded__field">
            Convives
            <select
              value={partySize}
              onChange={(e) => setPartySize(Number(e.target.value) || 1)}
              disabled={!interactive}
            >
              {Array.from({ length: maxParty }, (_, i) => i + 1).map((n) => (
                <option key={n} value={n}>
                  {n} pers.
                </option>
              ))}
            </select>
          </label>
        </div>

        <p className="jop-classic-reservation-embedded__section-title">Choisir une date</p>
        {!availabilityConfigured ? (
          <p className="jop-classic-reservation-embedded__hint">
            Configurez les horaires dans l&apos;administration commerce pour activer le calendrier.
          </p>
        ) : null}
        <div
          className={
            !availabilityConfigured ? 'jop-classic-reservation-embedded__calendar--off' : undefined
          }
        >
          <CommerceMonthCalendar
            className="jop-classic-reservation-embedded__calendar"
            value={selectedDate}
            onChange={(d) => {
              setError('');
              if (!d) {
                setSelectedDate(null);
                setTimeSlot('');
                return;
              }
              if (isDayDisabled(d)) {
                setError('Cette date n’est pas disponible.');
                return;
              }
              setSelectedDate(d);
              setTimeSlot('');
            }}
            minDate={minDate}
            accentColor={accent}
            isDayDisabled={isDayDisabled}
          />
        </div>

        {selectedDate ? (
          <fieldset className="jop-classic-reservation-embedded__times">
            <legend>Horaire</legend>
            {availableSlots.length === 0 ? (
              <p className="jop-classic-reservation-embedded__hint">Aucun créneau ce jour.</p>
            ) : (
              <div className="jop-classic-reservation-embedded__slot-grid">
                {availableSlots.map((slot) => (
                  <label key={slot} className="jop-classic-reservation-embedded__slot">
                    <input
                      type="radio"
                      name="classic-res-time"
                      value={slot}
                      checked={timeSlot === slot}
                      onChange={() => setTimeSlot(slot)}
                      disabled={!interactive}
                    />
                    <span>{slot}</span>
                  </label>
                ))}
              </div>
            )}
          </fieldset>
        ) : null}

        <div className="jop-classic-reservation-embedded__row">
          <label className="jop-classic-reservation-embedded__field">
            Nom
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Prénom et nom"
              autoComplete="name"
              disabled={!interactive}
            />
          </label>
          <label className="jop-classic-reservation-embedded__field">
            E-mail
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vous@exemple.fr"
              autoComplete="email"
              disabled={!interactive}
            />
          </label>
        </div>
        <label className="jop-classic-reservation-embedded__field">
          Téléphone
          <input
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="06 …"
            autoComplete="tel"
            disabled={!interactive}
          />
        </label>
        <label className="jop-classic-reservation-embedded__field">
          Message <span className="jop-classic-reservation-embedded__optional">(facultatif)</span>
          <textarea
            rows={2}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Allergies, occasion…"
            disabled={!interactive}
          />
        </label>

        {error ? <p className="jop-classic-reservation-embedded__error">{error}</p> : null}
        {!interactive ? (
          <p className="jop-classic-reservation-embedded__hint">
            Aperçu éditeur — réservation active sur le site publié.
          </p>
        ) : null}
        <button
          type="submit"
          className="jop-classic-reservation-embedded__submit"
          disabled={busy || !interactive || !availabilityConfigured}
          style={{ backgroundColor: btnBg, color: btnText }}
        >
          {submitLabel}
        </button>
      </form>
    </div>
  );
}
